import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { PuffLoader } from 'react-spinners';

import { startPlaid } from 'actions/plaid';
import { useConfig } from 'config/ConfigContext';

import style from './style.scss';

const withPlaidSessionId = (WrappedComponent) => {
  const HOC = (props) => {
    const appConfig = useConfig();
    const location = useLocation();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const workflow = useSelector((state) => state.workflow);
    const [sessionId, setSessionId] = useState(null);
    const [linkToken, setLinkToken] = useState(null);

    useEffect(() => {
      const applicationId = searchParams.get('appId');
      const appId = applicationId || get(workflow, 'attributes.entityId');
      if (appId) {
        dispatch(startPlaid({
          data: {
            entityType: 'application',
            entityId: applicationId || appId,
          },
          apiUrl: `${appConfig.apiUrl}/plaid`,
          url: '/session',
          success: (session) => {
            setSessionId(session.id);
            setLinkToken(session.linkToken);
          },
          fail: (err) => {
            console.log('Initiating Session failed', err);
          },
        }));
      }
    }, [location.pathname]);

    return sessionId ?
      <WrappedComponent {...props} sessionId={sessionId} linkToken={linkToken} />
      :
      <div className={style.plaidContainer}>
        <PuffLoader
          color="#f44242"
          size={100}
        />
      </div>;
  };

  HOC.propTypes = {
  };

  return HOC;
};

export default withPlaidSessionId;
